import React, { Component } from 'react';
import {
    Row,
    Col,
    Button
} from "reactstrap";
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';
class TSListPay extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            renderItem: [],
            /*
            name: props.name,
            placeholder: props.placeholder,
            isFocus: false,
            value: '',
            icon: props.icon
            */
        };

        this.setFocus = this.setFocus.bind(this);
        //this.handleChange = this.handleChange.bind(this);
    }

    setFocus(e) {
        this.setState(state => ({
            isFocus: e
        }));
    }

    handleChange = event => {
        this.setState({ value: event.target.value });
        if (this.props.onChange)
            this.props.onChange(event);
    };

    componentDidMount() {
        const currentUser = authenticationService.currentUserValue;
        
        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/mytele', requestOptions)
                //.then(response => response.json())
                .then(handleResponse)
                .then(
                    (result) => {
                        //console.log(result.data);
                        this.setState({ renderItem: result.data });
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }

        
    }
    /*
    handleChange(event) {

        this.setState({ value: event.target.value });
        if (this.props.onChange)
            this.props.onChange(event);
    }
    */
    render() {


        const content = this.state.renderItem.map((post) =>
            <Row key={post.teleID} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
                <Col md="3" xs="6">
                    {post.appointDatetimeText}
                </Col>
                <Col md="2" xs="6">
                    {post.serviceTypeName}
                </Col>
                <Col md="3" xs="12">
                    สถานะ : {post.flowStatusName}

                </Col>
                <Col md="4" xs="12">
                    {
                         //Confirm Payment
                        (post.flowStatus == 3 || post.flowStatus == 4) ?
                            <Button color="primary" size="sm" onClick={() => window.location.href = 'https://liff.line.me/1654063801-JpnXVx2a/lineliff2?id='+post.teleID/*this.handleConfirm()*/ } >
                                <i className="fas fa-money-bill-wave"></i> {(post.flowStatus == 3) ? "ยืนยันการชำระเงิน/แนบสลิป" : "ยืนยัน/แนบสลิป เพิ่มเติม"}
                        </Button>
                        :
                        ""
                    }
                    
                    {
                        //Tracking Number
                        (post.flowStatus == 6 && post.jsonTrackingNo != null && post.jsonTrackingNo.indexOf('[{"barcode":"') >= 0) ?
                            
                            JSON.parse(post.jsonTrackingNo).map(function (track) {
                                return (
                                    <div>
                                        หมายเลขติดตามพัสดุ. : <a href={"https://track.thailandpost.co.th/?trackNumber=" + track.barcode} target="_blank"> {track.barcode} </a>
                                    </div>
                                )
                            })
                           :
                           ""
                    }
                  

                </Col>
            </Row>

        );

        return (
            <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>            
                {content}
             </div>
        );
    }
}
export default TSListPay;